import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import CardTitle from '../../common/CardTitle'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import Button from 'srcReact/components/common2/Button'
import ModalWithPost from '../../common/ModalWithPost'
import { getMentionFormat } from 'srcReact/components/common2/RichTextEditor/util'
import { groupActions } from 'srcReact/GroupPage'
import { useDispatch, useSelector } from 'react-redux'

function MostActiveMembers({ objectId, data, selectedDuration }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [users, setUsers] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentDuration, setCurrentDuration] = useState('')
  const {
    common: { isMobile, isNative },
    group: {
      addPost: { loading, success, error }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (selectedDuration) {
      setCurrentDuration(selectedDuration)
    }
    if (data && data[selectedDuration]) {
      setUsers(data[selectedDuration].Most_active_members)
    }
  }, [data, selectedDuration])

  const tags = () =>
    users
      .map((user) => {
        return getMentionFormat(user.user_info.id, user.user_info.firstname)
      })
      .join(', ')

  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const handlePost = (message) => {
    dispatch(
      groupActions.addComment(objectId, message, () => {
        setTimeout(closeModal, 3000)
      })
    )
  }

  return data && data[currentDuration]?.Most_active_members ? (
    <div className={`${styles.card} ${parentStyles.card} `}>
      <div className={styles.activityHeader}>
        <CardTitle title={t('dashboard.mostActiveMembers.empty.titleBox')} className={styles.heading} />
      </div>
      {users?.length > 0 ? (
        <div className={styles.users}>
          {users[1] && (
            <Avatar
              imgWrapperSize={isMobile || isNative ? 'small48' : 'medium60'}
              userId={users[1].user_info.id}
              profilePicture={users[1].user_info.profile_picture_data.profile_picture}
              firstname={users[1].user_info.firstname}
              lastname={users[1].user_info.lastname}
              mimeType={users[1].user_info.profile_picture_data.mime_type}
              originalTag={users[1].user_info.profile_picture_data.original_tag}
              isOriginal={users[1].user_info.profile_picture_data.is_original}
              customImageCSS={styles.avatar}
              containerCSS={styles.avatarWrapper1}
              showUserName={true}
              userNameCSS={styles.userName}
              withExpertiseGroup={users[1].user_info.with_expertise_group}
            />
          )}
          {users[0] && (
            <Avatar
              imgWrapperSize={isMobile || isNative ? 'medium60' : 'large'}
              userId={users[0].user_info.id}
              profilePicture={users[0].user_info.profile_picture_data.profile_picture}
              firstname={users[0].user_info.firstname}
              lastname={users[0].user_info.lastname}
              mimeType={users[0].user_info.profile_picture_data.mime_type}
              originalTag={users[0].user_info.profile_picture_data.original_tag}
              isOriginal={users[0].user_info.profile_picture_data.is_original}
              customImageCSS={styles.avatar}
              containerCSS={styles.avatarWrapper0}
              showUserName={true}
              userNameCSS={styles.userName}
              withExpertiseGroup={users[0].user_info.with_expertise_group}
            />
          )}
          {users[2] && (
            <Avatar
              imgWrapperSize={isMobile || isNative ? 'small' : 'small50'}
              userId={users[2].user_info.id}
              profilePicture={users[2].user_info.profile_picture_data.profile_picture}
              firstname={users[2].user_info.firstname}
              lastname={users[2].user_info.lastname}
              mimeType={users[2].user_info.profile_picture_data.mime_type}
              originalTag={users[2].user_info.profile_picture_data.original_tag}
              isOriginal={users[2].user_info.profile_picture_data.is_original}
              customImageCSS={styles.avatar}
              containerCSS={styles.avatarWrapper2}
              showUserName={true}
              userNameCSS={styles.userName}
              withExpertiseGroup={users[2].user_info.with_expertise_group}
            />
          )}
        </div>
      ) : null}
      {users?.length > 0 && (
        <Button
          style='orange'
          text={t('cheerThem.cheerButton')}
          handleClick={openModal}
          customStyle={styles.btnCheer}
        />
      )}

      {isModalOpen && (
        <ModalWithPost
          isOpen={isModalOpen}
          users={users}
          title={t('cheerThem.title')}
          subTitle={t('cheerThem.mostActiveMembers30D')}
          handleCancel={closeModal}
          handleConfirm={handlePost}
          labelText={t('postMessage.congMessage')}
          primaryBtnText={t('global.post')}
          secondaryBtnText={t('global.cancel')}
          defaultMessage={t('cheerThem.message', { tags: tags() })}
          isMessageRequied={true}
          loading={loading}
          errorMessage={error}
          successMessage={!loading && success ? t('global.messageSent') : ''}
          doCleaning={() => {
            dispatch(groupActions.clearCommentState())
          }}
        />
      )}
    </div>
  ) : null
}

export default MostActiveMembers
